import TransitionExpand from './components/Utility/TransitionExpand'
import FormError from './components/FormError'
import AddToCartBase from './components/Cart/AddToCartBase'
import AddToCart from './components/Cart/AddToCart'
import AddressItemBase from './components/Address/AddressItemBase'
import AddressItem from './components/Address/AddressItem'
import AddressesBase from './components/Address/AddressesBase'
import Addresses from './components/Address/Addresses'
import NewAddressFormBase from  './components/Address/NewAddressFormBase'
import NewAddressForm from  './components/Address/NewAddressForm'
import NewShippingAddressForm from  './components/Address/NewShippingAddressForm'
import NewBillingAddressForm from  './components/Address/NewBillingAddressForm'
import CartBase from './components/Cart/CartBase'
import Cart from './components/Cart/Cart'
import CartItemBase from './components/Cart/CartItemBase'
import CartItem from './components/Cart/CartItem'
import CartWidgetBase from './components/Cart/CartWidgetBase'
import CartWidget from './components/Cart/CartWidget'
import CartWidgetItem from './components/Cart/CartWidgetItem'
import CartWidgetToggleBase from './components/Cart/CartWidgetToggleBase'
import CartWidgetToggle from './components/Cart/CartWidgetToggle'
import CheckoutBase from './components/Checkout/CheckoutBase'
import Checkout from './components/Checkout/Checkout'
import CheckoutSteps from './components/Checkout/CheckoutSteps'
import CheckoutStep from './components/Checkout/CheckoutStep'
import CustomerData from './components/Checkout/Steps/CustomerData'
import AuthenticatedCustomerDataForm from './components/Checkout/Steps/CustomerData/AuthenticatedCustomerDataForm'
import BillingAddressSelector from './components/Checkout/Steps/CustomerData/BillingAddressSelector'
import ShippingAddressSelector from './components/Checkout/Steps/CustomerData/ShippingAddressSelector'
import GuestCustomerDataForm from './components/Checkout/Steps/CustomerData/GuestCustomerDataForm'
import PaymentMode from './components/Checkout/Steps/PaymentMode'
import ShippingMode from './components/Checkout/Steps/ShippingMode'
import PickupPoint from './components/Checkout/Steps/ShippingModes/PickupPoint'
import PickPackPoint from './components/Checkout/Steps/ShippingModes/PickPackPoint'
import SummaryStep from './components/Checkout/Steps/SummaryStep'
import Authentication from './components/Checkout/Steps/Authentication'
import PhoneNumberField from './components/Checkout/Steps/CustomerData/PhoneNumberField'
// DISCOUNTS - ITEM
import ProductDiscountBase from './components/Discounts/Item/ProductDiscountBase'
import CartItemRegularCustomerDiscount from './components/Discounts/Item/CartItemRegularCustomerDiscount'
import CartItemAccumulatingOrderCostDiscount from './components/Discounts/Item/CartItemAccumulatingOrderCostDiscount'
import PercentProductDiscount from './components/Discounts/Item/PercentProductDiscount'
import ValueProductDiscount from './components/Discounts/Item/ValueProductDiscount'
import XPlusYProductDiscount from './components/Discounts/Item/XPlusYProductDiscount'
import CartItemPercentCoupon from './components/Discounts/Item/CartItemPercentCoupon'
// DISCOUNTS - CART
import AccumulatingOrderCostDiscount from './components/Discounts/Cart/AccumulatingOrderCostDiscount'
import CouponBase from './components/Discounts/Cart/CouponBase'
import CustomerDiscountBase from './components/Discounts/Cart/CustomerDiscountBase'
import GiftCardCoupon from './components/Discounts/Cart/GiftCardCoupon'
import PercentCoupon from './components/Discounts/Cart/PercentCoupon'
import RegularCustomerDiscount from './components/Discounts/Cart/RegularCustomerDiscount'
import ValueCoupon from './components/Discounts/Cart/ValueCoupon'
// DISCOUNTS
import CouponRedeemFormBase from './components/Discounts/CouponRedeemFormBase'
import CouponRedeemForm from './components/Discounts/CouponRedeemForm'

export default function (Vue) {
    Vue.component('transition-expand', TransitionExpand)
    Vue.component('form-error', FormError)
    Vue.component('add-to-cart-base', AddToCartBase)
    Vue.component('add-to-cart', AddToCart)
    Vue.component('address-item-base', AddressItemBase)
    Vue.component('address-item', AddressItem)
    Vue.component('addresses-base', AddressesBase)
    Vue.component('addresses', Addresses)
    Vue.component('new-address-form-base', NewAddressFormBase)
    Vue.component('new-address-form', NewAddressForm)
    Vue.component('new-shipping-address-form', NewShippingAddressForm)
    Vue.component('new-billing-address-form', NewBillingAddressForm)
    Vue.component('cart-base', CartBase)
    Vue.component('cart', Cart)
    Vue.component('cart-item-base', CartItemBase)
    Vue.component('cart-item', CartItem)
    Vue.component('cart-widget-base', CartWidgetBase)
    Vue.component('cart-widget', CartWidget)
    Vue.component('cart-widget-item', CartWidgetItem)
    Vue.component('cart-widget-toggle-base', CartWidgetToggleBase)
    Vue.component('cart-widget-toggle', CartWidgetToggle)
    Vue.component('checkout-base', CheckoutBase)
    Vue.component('checkout', Checkout)
    Vue.component('checkout-steps', CheckoutSteps)
    Vue.component('checkout-step', CheckoutStep)
    Vue.component('customer-data', CustomerData)
    Vue.component('authenticated-customer-data-form', AuthenticatedCustomerDataForm)
    Vue.component('billing-address-selector', BillingAddressSelector)
    Vue.component('shipping-address-selector', ShippingAddressSelector)
    Vue.component('guest-customer-data-form', GuestCustomerDataForm)
    Vue.component('payment-mode', PaymentMode)
    Vue.component('shipping-mode', ShippingMode)
    Vue.component('pickup-point', PickupPoint)
    Vue.component('pick-pack-point', PickPackPoint)
    Vue.component('summary-step', SummaryStep)
    Vue.component('authentication', Authentication)
    Vue.component('phone-number-field', PhoneNumberField)
    // DISCOUNTS - ITEM
    Vue.component('ProductDiscountBase', ProductDiscountBase)
    Vue.component('CartItemRegularCustomerDiscount', CartItemRegularCustomerDiscount)
    Vue.component('CartItemAccumulatingOrderCostDiscount', CartItemAccumulatingOrderCostDiscount)
    Vue.component('PercentProductDiscount', PercentProductDiscount)
    Vue.component('ValueProductDiscount', ValueProductDiscount)
    Vue.component('XPlusYProductDiscount', XPlusYProductDiscount)
    Vue.component('CartItemPercentCoupon', CartItemPercentCoupon)
    // DISCOUNTS - CART
    Vue.component('CustomerDiscountBase', CustomerDiscountBase)
    Vue.component('RegularCustomerDiscount', RegularCustomerDiscount)
    Vue.component('AccumulatingOrderCostDiscount', AccumulatingOrderCostDiscount)
    Vue.component('CouponBase', CouponBase)
    Vue.component('GiftCardCoupon', GiftCardCoupon)
    Vue.component('PercentCoupon', PercentCoupon)
    Vue.component('ValueCoupon', ValueCoupon)
    // DISCOUNTS
    Vue.component('CouponRedeemFormBase', CouponRedeemFormBase)
    Vue.component('CouponRedeemForm', CouponRedeemForm)
}
